import { useSelector } from 'react-redux';
import { getLiveCameras, getCamerasStatus } from './index';

export const useLiveCameras = () => useSelector(getLiveCameras);
export const useLiveCamerasStatus = () => useSelector(getCamerasStatus);
